(() => {
  'use strict';
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const config = JSON.parse($('#shop-config')?.textContent || '{}');
  const assetMap = JSON.parse($('#asset-map')?.textContent || '{}');
  const root = config.root || '/';
  const money = value => new Intl.NumberFormat('de-DE', {style: 'currency', currency: config.currency || 'EUR'}).format(value / 100);
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const status = text => { const el = $('#status-message'); if (el) el.textContent = text; };
  const icons = {
    minus:'<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M5 12h14"/></svg>',
    plus:'<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M5 12h14M12 5v14"/></svg>',
    arrow:'<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M4 12h15M13 5l7 7-7 7"/></svg>'
  };
  let cartBusy = false;
  let activeDialogTrigger;
  const cartDialog = $('#cart-drawer');
  function openDialog(dialog, trigger) { if (!dialog || dialog.open) return; closeMenu(); activeDialogTrigger = trigger || document.activeElement; dialog.showModal(); }
  function closeDialog(dialog) { dialog.close(); activeDialogTrigger?.focus?.(); }
  $$('dialog').forEach(dialog => {
    $('[data-close-dialog]', dialog)?.addEventListener('click', () => closeDialog(dialog));
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeDialog(dialog);
    });
  });
  const menuToggle = $('[data-menu-toggle]');
  const menu = $('#mobile-menu');
  function closeMenu() { if (!menu || !menuToggle) return; menu.hidden = true; menuToggle.setAttribute('aria-expanded', 'false'); menuToggle.setAttribute('aria-label', 'Menü öffnen'); }
  menuToggle?.addEventListener('click', () => {
    const open = menu.hidden;
    menu.hidden = !open;
    menuToggle.setAttribute('aria-expanded', String(open));
    menuToggle.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen');
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && menu && !menu.hidden) { closeMenu(); menuToggle.focus(); } });
  document.addEventListener('click', event => { if (menu && !menu.hidden && !menu.contains(event.target) && !menuToggle.contains(event.target)) closeMenu(); });
  $$('a', menu || document.createElement('div')).forEach(link => link.addEventListener('click', closeMenu));
  window.matchMedia('(min-width:901px)').addEventListener('change', event => { if (event.matches) closeMenu(); });
  $$('[data-open-search]').forEach(button => button.addEventListener('click', () => { openDialog($('#search-dialog'), button); $('#search-input')?.focus(); }));
  $$('[data-open-video]').forEach(button => button.addEventListener('click', () => { const dialog = $('#video-dialog'); openDialog(dialog, button); $('video', dialog)?.play().catch(() => {}); }));
  $('#video-dialog')?.addEventListener('close', () => $('video', $('#video-dialog'))?.pause());
  async function request(url, options = {}) {
    const response = await fetch(root + url, {credentials:'same-origin', cache:'no-store', ...options, headers:{'Accept':'application/json', ...options.headers}});
    let data;
    try { data = await response.json(); } catch { throw new Error('Die Verbindung ist unterbrochen. Bitte versuche es erneut.'); }
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'Der Warenkorb konnte nicht aktualisiert werden. Bitte versuche es erneut.');
    return data;
  }
  function renderCart(cart) {
    $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
    const body = $('[data-cart-body]');
    $('[data-cart-summary]').hidden = cart.item_count === 0;
    $('[data-cart-total]').textContent = money(cart.total_price);
    if (!cart.item_count) {
      body.innerHTML = `<div class="empty-state"><div class="cart-empty-symbol">${icons.plus}</div><h3>Hier ist noch Platz für Abenteuer.</h3><p>Finde die passende Ausrüstung für deinen nächsten Weg.</p><a class="button button-dark" href="${esc(root)}collections/all">Ausrüstung entdecken ${icons.arrow}</a></div>`;
      return;
    }
    body.innerHTML = cart.items.map(item => {
      const handle = item.handle || item.product?.handle;
      const bundle = handle === '230-led-stirnlampe-2er-set';
      const img = item.featured_image?.url || item.image || assetMap[handle] || '';
      return `<article class="cart-line" data-cart-key="${esc(item.key)}">
        <a href="${esc(item.url)}">${img ? `<img src="${esc(img)}" alt="${esc(item.product_title || item.title)}" width="85" height="100">` : ''}</a>
        <div><div class="cart-line-top"><h3><a href="${esc(item.url)}">${esc(item.product_title || item.title)}</a></h3><span class="cart-line-price">${money(item.final_line_price)}</span></div>
        ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-variant">${esc(item.variant_title)}</p>` : ''}
        <div class="cart-line-controls"><div class="quantity-control"><button type="button" data-cart-step="-1" aria-label="Menge von ${esc(item.product_title || item.title)} verringern">${icons.minus}</button><input type="number" value="${item.quantity}" min="0" max="99" inputmode="numeric" data-cart-quantity aria-label="Menge für ${esc(item.product_title || item.title)}"><button type="button" data-cart-step="1" aria-label="Menge von ${esc(item.product_title || item.title)} erhöhen">${icons.plus}</button></div><button type="button" class="remove-button" data-cart-remove>Entfernen</button></div>
        ${bundle ? `<p class="cart-bundle-note">${item.quantity} Set${item.quantity > 1 ? 's' : ''} = ${item.quantity * 2} Stirnlampen</p>` : ''}
        ${(item.line_level_discount_allocations || []).map(d => `<p class="cart-bundle-note">${esc(d.discount_application.title)}: −${money(d.amount)}</p>`).join('')}</div></article>`;
    }).join('');
  }
  async function loadCart() { const cart = await request('cart.js'); renderCart(cart); return cart; }
  $$('[data-open-cart]').forEach(button => button.addEventListener('click', async event => {
    event.preventDefault();
    $('[data-cart-error]').textContent = '';
    openDialog(cartDialog, button);
    try { await loadCart(); } catch (error) { $('[data-cart-error]').textContent = error.message; $('[data-cart-body]').innerHTML = `<p>Dein Warenkorb ist gerade nicht erreichbar.</p><a class="text-link" href="${esc(root)}cart">Warenkorb als Seite öffnen ${icons.arrow}</a>`; }
  }));
  $$('[data-product-form]').forEach(form => form.addEventListener('submit', async event => {
    event.preventDefault();
    if (form.dataset.busy || !form.reportValidity()) return;
    form.dataset.busy = 'true';
    const errorNode = $('.form-error', form);
    if (errorNode) errorNode.textContent = '';
    const button = $('button[type=submit]', form);
    const original = button.innerHTML;
    button.disabled = true;
    button.setAttribute('aria-busy','true');
    try {
      const data = new FormData(form);
      const quantity = Number(data.get('quantity')) || 1;
      if (!Number.isInteger(quantity) || quantity < 1 || quantity > 99) throw new Error('Bitte wähle eine Menge zwischen 1 und 99.');
      await request('cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({items:[{id:data.get('id'), quantity}]})});
      await loadCart();
      $('[data-cart-error]').textContent = '';
      openDialog(cartDialog, button);
      status('Zum Warenkorb hinzugefügt.');
    } catch (error) { if (errorNode) { errorNode.classList.remove('sr-only'); errorNode.textContent = error.message; } status(error.message); }
    finally { delete form.dataset.busy; button.innerHTML = original; button.disabled = false; button.removeAttribute('aria-busy'); }
  }));
  async function changeQuantity(key, quantity) {
    if (cartBusy) return;
    if (!Number.isInteger(quantity) || quantity < 0 || quantity > 99) { $('[data-cart-error]').textContent = 'Bitte wähle eine Menge zwischen 0 und 99.'; return; }
    cartBusy = true;
    $('[data-cart-error]').textContent = '';
    $$('button,input', $('[data-cart-body]')).forEach(el => el.disabled = true);
    try {
      const cart = await request('cart/change.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity})});
      renderCart(cart); status('Warenkorb aktualisiert.');
      const updated = $$('[data-cart-key]').find(el => el.dataset.cartKey === key);
      (updated?.querySelector('[data-cart-quantity]') || $('[data-close-dialog]', cartDialog))?.focus();
    } catch(error) { $('[data-cart-error]').textContent = error.message; $$('button,input', $('[data-cart-body]')).forEach(el => el.disabled = false); }
    finally { cartBusy = false; }
  }
  cartDialog?.addEventListener('click', event => {
    const button = event.target.closest('[data-cart-step],[data-cart-remove]');
    if (!button) return;
    const line = button.closest('[data-cart-key]');
    const input = $('[data-cart-quantity]', line);
    changeQuantity(line.dataset.cartKey, button.hasAttribute('data-cart-remove') ? 0 : Number(input.value) + Number(button.dataset.cartStep));
  });
  cartDialog?.addEventListener('change', event => {
    if (!event.target.matches('[data-cart-quantity]')) return;
    changeQuantity(event.target.closest('[data-cart-key]').dataset.cartKey, Number(event.target.value));
  });
  $$('[data-quantity]').forEach(button => button.addEventListener('click', () => {
    const input = $('input', button.closest('.quantity-control'));
    input.value = Math.max(1, Math.min(99, Number(input.value) + Number(button.dataset.quantity)));
    input.dispatchEvent(new Event('change', {bubbles:true}));
  }));
  const variantSelect = $('[data-variant-select]');
  if (variantSelect) {
    const variants = JSON.parse($('[data-product-variants]').textContent);
    variantSelect.addEventListener('change', () => {
      const variant = variants.find(v => String(v.id) === variantSelect.value);
      if (!variant) return;
      $$('[data-product-price]').forEach(el => el.textContent = money(variant.price));
      $$('[data-add-button]').forEach(button => { button.disabled = !variant.available; $('span', button).textContent = variant.available ? 'In den Warenkorb' : 'Zurzeit nicht verfügbar'; });
      const compare = $('[data-compare-price]');
      if (compare) { compare.hidden = !(variant.compare_at_price > variant.price); compare.textContent = money(variant.compare_at_price || 0); }
      const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
    });
  }
  $$('[data-gallery-image]').forEach(button => button.addEventListener('click', () => {
    const main = $('#main-product-image');
    main.src = button.dataset.galleryImage;
    main.alt = $('img', button).alt;
    $$('[data-gallery-image]').forEach(item => { item.classList.toggle('is-active', item === button); item.setAttribute('aria-pressed', String(item === button)); });
  }));
  $('[data-zoom]')?.addEventListener('click', event => {
    const source = $('#main-product-image');
    if (!source) return;
    const image = $('[data-zoom-image]'); image.src = source.src; image.alt = source.alt;
    openDialog($('#image-dialog'), event.currentTarget);
  });
  $$('[data-auto-submit]').forEach(select => select.addEventListener('change', () => select.form.requestSubmit()));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if ('IntersectionObserver' in window && !reduceMotion.matches) {
    document.documentElement.classList.add('js-motion');
    const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } }), {threshold:.08});
    $$('.reveal').forEach(el => observer.observe(el));
  }
  const sticky = $('[data-sticky-buy]');
  const purchaseForm = $('#product-form');
  if (sticky && purchaseForm && 'IntersectionObserver' in window) {
    new IntersectionObserver(entries => entries.forEach(entry => { const shown = !entry.isIntersecting && entry.boundingClientRect.top < 0; sticky.classList.toggle('is-visible', shown); sticky.inert = !shown; sticky.setAttribute('aria-hidden', String(!shown)); }), {threshold:0}).observe(purchaseForm);
  }
  document.addEventListener('shopify:section:load', () => location.reload());
})();

/* v2.3 — « Cookie-Einstellungen » : le lien n'apparaît que si la bannière cookies de Shopify est active
   (Réglages → Confidentialité des clients). Il rouvre ses préférences : retirer son consentement doit
   être aussi simple que le donner. */
(function () {
  function init() {
    var buttons = document.querySelectorAll('[data-cookie-settings]');
    if (!buttons.length) return;
    var tries = 0;
    (function poll() {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        buttons.forEach(function (b) {
          b.hidden = false;
          b.addEventListener('click', function () { window.privacyBanner.showPreferences(); });
        });
      } else if (tries++ < 20) {
        setTimeout(poll, 500);
      }
    })();
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
